import React, { Component } from 'react'

import ReactTooltip from 'react-tooltip';

export default class About extends Component {
  render() {
    return (
        <React.Fragment>
            <ReactTooltip></ReactTooltip>
            <section id="about" className="sichkovskyi__about bg-grey-darker text-grey-lighter">
                <div className="container mx-auto sichkovskyi__about-grid">
                    <section className="sichkovskyi__about-cell-1">
                        <p className="text-3xl text-grey-lighter font-bold mb-6">
                            I'm Yurii, a freelance full-stack web developer
                        </p>
                        <p className="text-grey-lighter leading-normal">
                            I am passionate about making fast modern websites and cutting edge technologies including progressive web-apps.
                            Over the years I've been involved in various social media projects and have experience with building custom solutions.
                        </p>
                        <p className="text-grey-lighter leading-normal mt-4 text-sm">
                            My other passion is music. I compose, record and mix for <a href="https://konturmusic.bandcamp.com/" className="text-grey-lighter hover:text-grey-light">my band</a> and I was involved in <a href="javascript:void(0)" className="text-grey-lighter hover:text-grey-light" data-tip="Sorry, this project is long dead so I can't link to it">web-radio project</a> as sole technical person.
                        </p>
                    </section>
                    <section className="sichkovskyi__about-cell-2">
                        <p className="text-2xl text-grey-lighter font-bold mb-6">
                            I worked with:
                        </p>
                        <div className="text-grey-lighter leading-normal">
                            <p className="font-bold">Back-end:</p>
                            <p className="font-light text-sm">NodeJS, PHP, Ruby on Rails, MySQL, PostgreSQL, MongoDB, Redis</p>

                            <p className="font-bold mt-2">Front-end:</p>
                            <p className="font-light text-sm">React (and Redux), Vue (and Vuex), jQuery, Babel, Webpack, SCSS, PostCSS, Bootstrap 3 and 4, Tailwind, Gulp, three.js, Web Animations API, SVG animations</p>

                            <p className="font-bold mt-2">Cloud and infrastucture:</p>
                            <p className="font-light text-sm">Google Cloud, Amazon AWS, Heroku, various Linux VPS</p>

                            <p className="mt-4 font-light text-sm">If your technology is not in the list, but you like how I do things – still <span className="underline">contact me</span> 🙂 I learn very fast.</p>
                        </div>
                    </section>
                    <section className="sichkovskyi__about-cell-3">
                        <div className="text-2xl text-grey-lighter font-bold mb-6 text-center md:text-left">
                            Contact me:
                        </div>
                        <div className="text-grey-lighter leading-normal text-center md:text-left mb-6">
                            <a href="https://github.com/filingroove" className="mr-4 md:mr-2 text-grey-lighter hover:text-pink-dark text-3xl md:text-xl">
                                <i className="fab fa-github"></i>
                            </a>
                            <a href="https://t.me/sichkovskyi" className="mr-4 md:mr-2 text-grey-lighter hover:text-blue text-3xl md:text-xl">
                                <i className="fab fa-telegram"></i>
                            </a>
                            <a href="https://instagram.com/sichkovskyi_music" className="mr-4 md:mr-2 text-grey-lighter hover:text-pink-dark text-3xl md:text-xl">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://codepen.io/filingroove" className="mr-4 md:mr-2 text-grey-lighter hover:text-grey-light text-3xl md:text-xl">
                                <i className="fab fa-codepen"></i>
                            </a>
                            <a href="https://soundcloud.com/filingroove" className="mr-4 md:mr-2 text-grey-lighter hover:text-orange-dark text-3xl md:text-xl">
                                <i className="fab fa-soundcloud"></i>
                            </a>
                            <a href="https://konturmusic.bandcamp.com/" className="mr-4 md:mr-2 text-grey-lighter hover:text-blue-light text-3xl md:text-xl">
                                <i className="fab fa-bandcamp"></i>
                            </a>
                            <a href="mailto:filingr000ve@gmail.com" className="mr-4 md:mr-2 text-grey-lighter hover:text-red-light text-3xl md:text-xl">
                                <i className="fas fa-envelope"></i>
                            </a>



                            <p className="mt-4 text-sm font-light">

                            </p>
                        </div>
                    </section>
                </div>
            </section>
      </React.Fragment>
    )
  }
}
